import { Environment, RemoteEnv } from '@abp/ng.core';

export const environment = {
  appVersion: require('../../package.json').version,
  remoteEnv: {
    url: 'assets/environment.json',
    mergeStrategy: 'deepmerge',
  } as RemoteEnv,
  production: false,
  application: {
    baseUrl: null,
    name: 'ERP',
    logoUrl: '/assets/favicon.ico',
  },
  apis: {
    GoliathShapingManagement: {
      rootNamespace: 'Digiwall.GoliathShapingManagement',
    },
    GoliathAccounting: {
      rootNamespace: 'Digiwall.GoliathAccounting',
    },
    Reporting: {
      rootNamespace: 'Odyssey.Reporting',
    },
    GoliathProducts: {
      rootNamespace: 'Digiwall.GoliathProducts',
    },
    GoliathContacts: {
      rootNamespace: 'Digiwall.GoliathContacts',
    },
    GoliathCore: {
      rootNamespace: 'Digiwall.GoliathCore',
    },
    GoliathDocuments: {
      rootNamespace: 'Digiwall.GoliathDocuments',
    },
    Core: {
      rootNamespace: 'DigiWall.Core',
    },
    default: {
      url: 'https://localhost:44346',
      rootNamespace: 'Maffle.ERP',
    },
  },
} as Environment;
